import { render, staticRenderFns } from "./SaleProgramDetail.vue?vue&type=template&id=54ddfa08"
import script from "./SaleProgramDetail.vue?vue&type=script&lang=js"
export * from "./SaleProgramDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports